module.exports = new __parcel__URL__("25420_v.5608d74d.jpg").toString();